import React, { useEffect, createElement } from 'react';
const PIXEL_ID = '941894498720185';
declare global {
  interface Window {
    fbq?: any;
    _fbq?: any;
  }
}
/**
 * Meta Pixel — PageView only.
 * Implementation injects Meta's exact base code into <head> so the Pixel Helper
 * extension can detect it like on any normal site.
 */
export const MetaPixel = () => {
  useEffect(() => {
    // Already initialized once — just fire PageView again (SPA navigation)
    if (window.fbq) {
      window.fbq('track', 'PageView');
      return;
    }
    // 1. Inject Meta's exact base code as a <script> in <head>.
    //    Using innerHTML on a real <script> element ensures it executes
    //    in the global scope (so `fbq` becomes a real window global the
    //    Pixel Helper can introspect).
    const baseScript = document.createElement('script');
    baseScript.type = 'text/javascript';
    baseScript.innerHTML = `
      !function(f,b,e,v,n,t,s)
      {if(f.fbq)return;n=f.fbq=function(){n.callMethod?
      n.callMethod.apply(n,arguments):n.queue.push(arguments)};
      if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
      n.queue=[];t=b.createElement(e);t.async=!0;
      t.src=v;s=b.getElementsByTagName(e)[0];
      s.parentNode.insertBefore(t,s)}(window, document,'script',
      'https://connect.facebook.net/en_US/fbevents.js');
      fbq('init', '${PIXEL_ID}');
      fbq('track', 'PageView');
    `;
    document.head.appendChild(baseScript);
    // 2. Inject the noscript fallback pixel for users with JS disabled.
    const noscript = document.createElement('noscript');
    noscript.innerHTML = `<img height="1" width="1" style="display:none" src="https://www.facebook.com/tr?id=${PIXEL_ID}&ev=PageView&noscript=1" />`;
    document.head.appendChild(noscript);
  }, []);
  return null;
};